<template>
    <div
        style="width: 100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 50px;">
        <!-- <div class="text"></div> -->
        <my-text-one :title="teamName + '团队乐声库'" :textContent="teamName + '团队乐声库'"></my-text-one>
        <div
            style="width: 90%;margin-top: 50px;display: flex;flex-direction: column; justify-content: center;align-items: center;">
            <div style="width: 40%;">
                <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane v-for="item in typeTabs" :key="item.value" :name="item.value">
                        <span slot="label">{{ item.label }}</span>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="list-view">
                <el-row :gutter="20">
                    <el-col :span="8" v-for="i in playerNum" :key="i" @click="currentIndex = i" v-if="isTypeMatch(musicList[i-1] && musicList[i-1].type)">

                        <el-card :body-style="{ padding: '0px' }">
                            <div style="width: 100%;height: 150px;display: flex;flex-direction: row;">
                                <img :src="musicList[i-1].coverUrl" alt="" style="width: 150px;">
                                <div style="width: 100%;display: flex;flex-direction: column;margin-top: 10px;">
                                    <label style="font-size: 12pt;color: white;margin-left: 20px;">{{musicList[i-1].title}}</label>
                                    <div style="position: absolute;bottom: -20px;right: 160px;">
                                        <audio ref="audio" :src="musicList[i-1].music" controls></audio>
                                    </div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>

                </el-row>
            </div>
            <!-- <el-tabs type="border-card">
                <el-tab-pane label="配置管理">
                    <div style="height: 700px;background-color: white;"></div>
                </el-tab-pane>
                <el-tab-pane label="角色管理">角色管理</el-tab-pane>
                <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
            </el-tabs> -->
        </div>
        <div class="kuang">
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
        </div>
    </div>

</template>

<script>
import LivePlayer from '@liveqing/liveplayer'
import MyTextOne from "@/components/MyTextOne.vue";
export default {
    name: 'MusicList',
    components: {
        LivePlayer,
        MyTextOne,
    },
    data() {
        return {
            // 分屏布局
            playerNum: 0,

            musicList: [
                { title: '视频1', music: '' },
            ],
            dataForm: {
                key: ''
            },

            dataListLoading: false,
            addOrUpdateVisible: false,
            activeName: '0',
            selectTabName: '0',
        };
    },
    computed: {
      teamName () {
        return (this.$store && this.$store.state.brand && this.$store.state.brand.teamName) || '音愈童心'
      },
      typeTabs () {
        return (this.$store && this.$store.state.category && this.$store.state.category.music) || []
      }
    },
    methods: {
        isTypeMatch (type) {
            return String(type) === String(this.selectTabName)
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.$http({
                url: this.$http.adornUrl('/app/music/list'),
                method: 'get',
                params: this.$http.adornParams({
                    'page': this.pageIndex,
                    'limit': this.pageSize,
                    'key': this.dataForm.key
                })
            }).then(({ data }) => {
                console.log(data);
                if (data && data.code === 0) {
                    this.musicList = data.page.list
                    this.playerNum = data.page.totalCount
                } else {
                    this.musicList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        handleClick(tab, event) {
            this.selectTabName = tab.name
            console.log(this.selectTabName,this.musicList[0] && this.musicList[0].type);
        },
        syncActiveTab () {
            if (this.typeTabs.length && !this.typeTabs.some(i => String(i.value) === String(this.activeName))) {
                this.activeName = this.typeTabs[0].value
                this.selectTabName = this.typeTabs[0].value
            }
        },

    },
    watch: {
      typeTabs: {
        immediate: true,
        handler () { this.syncActiveTab() }
      }
    },
    mounted() {
        this.getDataList()
        

    },
    created() {
    }
}
</script>
<style lang="less" scoped>
/* 需要滚动条隐藏的列表 */
.list-view {
    width: 80%;
    height: 650px;
    margin-top: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
    display: none;
}

/deep/ .el-tabs__nav {
    //   font-size: 29px;
    // line-height: 55px;
    height: 50px;
}


::v-deep .el-tabs__item.is-active {
    color: skyblue; //选中
    opacity: 1;
}

::v-deep .el-tabs__item:hover {
    color: skyblue; //悬浮
    cursor: pointer;
    opacity: 1;
}

/deep/.el-tabs__item {
    /* 修改为您想要的文字大小 */
    font-size: 20pt !important;
    color: #fff;
    font-weight: bold;
}

/deep/.el-tabs__nav-wrap::after {
    /* 去掉下划线 */
    position: static !important;
}

/* 下划线颜色 */
::v-deep .el-tabs__active-bar {
    background-color: skyblue;
}

.el-card {
    background-color: rgba(255, 255, 255, 0.4) !important;

    box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6) !important;

    backdrop-filter: blur(50px) !important;
    border: none !important;
    border-radius: 5px !important;
}

.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
    margin-bottom: 30px
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

/**背景 **/

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.kuang {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
    position: absolute;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: inset 0 0 8px #fff;
    animation: flutter 10s infinite;
    opacity: 0;
}

@keyframes flutter {
    0% {
        transform: translateX(0);
        bottom: -100px;
        opacity: 1;
    }

    50% {
        transform: translateX(100px);
        opacity: 0.5;
    }


    100% {
        transform: translateX(0px);
        bottom: 100%;
        opacity: 0;

    }
}

.bubble:nth-child(1) {
    left: -10%;
    width: 50px;
    height: 50px;
    animation-duration: 9s;
    animation-delay: 0.1s;
}

.bubble:nth-child(2) {
    left: 15%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1.5s;

}

.bubble:nth-child(3) {
    left: 20%;
    width: 60px;
    height: 60px;
    animation-duration: 10s;



}

.bubble:nth-child(4) {
    left: 30%;
    width: 30px;
    height: 30px;
    animation-duration: 5.5s;
    animation-delay: 1.5s;

}

.bubble:nth-child(5) {
    left: 40%x;
    width: 50px;
    height: 50px;
    animation-duration: 12s;



}

.bubble:nth-child(6) {
    left: 50%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1s;

}

.bubble:nth-child(7) {
    left: 60%;
    width: 40px;
    height: 40px;
    animation-duration: 8s;
    animation-delay: 1s;

}

.bubble:nth-child(8) {
    left: 65%;
    width: 60px;
    height: 60px;
    animation-duration: 15s;

}

.bubble:nth-child(9) {
    left: 80%;
    width: 55px;
    height: 55px;
    animation-duration: 9s;
    animation-delay: 0.5s;

}

.bubble:nth-child(10) {
    left: 100%;
    width: 40px;
    height: 40px;
    animation-duration: 12s;

}

/** 发光字体 */
.nav {
    position: relative;
    font: 10 12pt '';
    color: #ffffff;
    cursor: pointer;
    font-weight: bold;
}

.nav:hover span {
    color: #FFFFFF;
    text-shadow: 0 0 10px #FFFFFF,
        0 0 20px #FFFFFF,
        0 0 30px #FFFFFF,
        0 0 50px #FFFFFF,
        0 0 70px #FFFFFF,
        0 0 90px #FFFFFF;

}
</style>
